const { AQL_LEVELS } = require('./aql');
const { genDefectCodes } = require('./defect-code');

const codeValues = {
  'A': { type_desc: 'Packaging & Labelling',
         codes: ['Damaged carton e.g. wet/bulging',
                 'Incorrect carton dimensions',
                 'Incorrect or missing carton label',
                 'Incorrect carton quantity',
                 'Carton content incorrect',
                 'Incorrect or missing polybag labels',
                 'Missing care label',
                 'Incorrect care label or fibre content percentage',
                 'No warning, recycle logo or air holes on polybag',
                 'Not scannable barcode',
                 'Incorrect size label',
                 'Missing country of origin label',
                 'Incorrect packaging method',
                 'Missing hangtag',
                 'Missing dessicant bag',
                 'Packaging connector or string is missing or damaged',
                 'Set is unmatched or missing pieces',
                 'Appearance defect on selling unit package',
                 'Other']},
  'B': { type_desc: 'Sample Comparison',
         codes: ['Approved sample not correspond to production']},
  'C': { type_desc: 'Measurements',
         codes: ['Out of tolerance',
                 'Variation within product',
                 'Minimum stretch requirement not achieved X X Garment']},
  'D': { type_desc: 'Raw Material',
         codes: ['Holes',
                 'Material Faults, Snagging',
                 'Shading between panels',
                 'Shading between batches',
                 'Shading between ribs/trims and panels',
                 'Fabric handle inconsistent between batches',
                 'Foreign material',
                 'Pilling visible',
                 'Barre in fabric',
                 'Glue mark',
                 'Deformation/twist on product surface',
                 'Poor plating',
                 'Rough surface/material',
                 'Missing coating/glitter/painting',
                 'Broken elastic',
                 'Misplaced, unopened uneven distance between punch hole(s)',
                 'Poor Colour Fastness',
                 'Other']},
  'E': { type_desc: 'Construction',
         codes: ['Broken/faulty stitching',
                 'Open seams',
                 'Seams grinning',
                 'Excessive stitch puckering (where not required)',
                 'Raw or frayed edges visible (where not required)',
                 'Missing or incorrect details e.g. missing pocket',
                 'Checks or stripes mismatched',
                 'Neckline not symmetrical X X Garment',
                 'Pockets not level',
                 'Fusing delaminating',
                 'Stitching needle hole damage',
                 'Button/buttonhole, hook/loop etc. mis-aligned',
                 'Labels - incorrect position or not level',
                 'Exposed elastic',
                 'Pinched/cut upper as a result of injection molding process',
                 'Other']},
  'F': { type_desc: 'Components',
         codes: ['Defective component e.g. zip/popper/stud',
                 'Component broken e.g. zip/button/popper/eyelet',
                 'Component missing e.g. zip/button/popper/eyelet',
                 'Insecure component e.g. button/badge/popper/eyelet',
                 'Malfunction of component e.g. zip/popper/stud',
                 'Other']},
  'G': { type_desc: 'Embellishments',
         codes: ['Print or embroidery - incorrect position or not level',
                 'Print register not as required',
                 'Obvious print defect',
                 'Print transfer to product',
                 'Embroidery - loose or insecure threads',
                 'Embroidery needle damage',
                 'Fabric/Main material distorted from embellishment',
                 'Other']},
  'H': { type_desc: 'Finishing',
         codes: ['Product is wet',
                 'Mildew, damp, mould present',
                 'Odour present',
                 'Product is marked, stained, scratched or dirty',
                 'Poor pressing eg over pressed/glazing',
                 'Pressing impressions visible e.g. pocket flaps',
                 'Surface damage or colour run resulting from laundering',
                 'Untrimmed threads over 1cm',
                 'Mending',
                 'Other']},
  'I': { type_desc: 'Metal Contamination',
         codes: ['Any sharp metal contamination inc. needles, staples',
                 'Kimble gun needle, metal fragments or pins present',
                 'Any other metal object not specified on the product',
                 'Any hand tool e.g. scissors, snips, tweezers',
                 'Sharp corners and edges',
                 'Rust/corrosion/oxidation']},
  'J': { type_desc: 'Infestation',
         codes: ['Dead insect/animal',
                 'Live insect/animal']},
  'K': { type_desc: 'Kidswear',
         codes: ['Use of Monofilament Thread',
                 'Untrimmed / hanging thread ends of more than 1cm',
                 'Drawstrings NOT bar tacked / secured',
                 'Functional cord in hood & neck area',
                 'Hanger loops longer than 75mm',
                 'Hood on sleepwear',
                 'Pumice / stone used on washed garment',
                 'Popper attachment misfire (leg protruding)',
                 'Popper incorrectly positioned over seam or stitching',
                 'Adjustable elastic caught within channel & not functional',
                 'Fusing attached to both armholes at chest',
                 'Length of drawcord incorrect versus safety manual',
                 'Ends of drawcord not secured versus safety manual',
                 'Any functional or decorative bows not compliant',
                 'Belts / Sashes hang below garment versus safety manual',
                 'Ends of ribbons to be secured and bartacked with no loose threads',
                 'Faux Fur pile length in excess of specified length ( NB & Mini)',
                 'Faux Fur pile length in excess of specified length',
                 'Fixed tails of bows <5cm',
                 'Pom Poms NOT correctly constructed and attached',
                 'Decorative metal chains attached with jump rings ( Older only)',
                 'Sharp edges on buckles, zips',
                 'Sharp edges on velcro',
                 'Spare components attached ( buttons, beads, eyelets)',
                 'Toggles insecurely attached',
                 'Any trim not securely attached',
                 'Use of non- approved trim supplier',
                 'Beads made from natural materials (refer to safety manual)',
                 'Bugle beads',
                 'Heat Seal on NB or Mini product',
                 'Floats longer than 1cm',
                 'Metal zip on NB & Mini',
                 'Buttonstitch not locked at end of sewing cycle',
                 'Button hand sewn - NB & Mini',
                 'Button incorrectly sewn',
                 'Lockstitch attachment method NOT used',
                 'Rusted or contaminated or faulty',
                 'Spare button',
                 'Dungaree hasps, clasps, sliders less than 2.5mm thickness',
                 'Exposed prongs',
                 'Prongs on buckles NB & MINI',
                 'Fasteners NOT ferrous',
                 'Top & bottom Claw stops',
                 'Elastic puller on zip',
                 'Non plastic molded top & bottom stops',
                 'Zip guard NOT used boys 5y and older',
                 'Zip used in under 5y boys',
                 'Zip pullers longer than 7.5mm',
                 'Flammability Labelling : Nightwear. Must be correct to legislation',
                 'All kidswear to state KAFF',
                 'Functional cords longer than 140mm extended and longer than 280mm closed',
                 'Belt sash less than 30mm']},
  'L': { type_desc: 'Leather',
         codes: ['Loose leather',
                 'Fat lines / Wrinkles',
                 'Veins',
                 'Open flaw / Scar / Briar mark',
                 'Surface removal',
                 'Tick bites / Insect damage',
                 'Hair cells',
                 'Squeaking',
                 'Other']},
  'M': { type_desc: 'Footwear',
         codes: ['Loose heel attachment',
                 'Loose strap attachment',
                 'Upper to sole bonding failure',
                 'Asymmetry in pair of shoes',
                 'Delamination of fusing / not bonded correctly',
                 'Upper misaligned with outsole',
                 'Insole/sock not stuck on',
                 'Injection moulding footwear :excessive residue',]},
};

module.exports = {
  AQL_LEVELS,
  DEFECT_CODES: genDefectCodes(codeValues),
};
